<section kb-card>
  <h3 slot="title" kb-heading type="bar">
    <ng-content select="[slot='title']"></ng-content>
  </h3>

  <div slot="content">
    <p kb-paragraph>
      <ng-content></ng-content>
    </p>

    <button type="button" kb-button class="button acceptAction" (click)="doAccept($event)" i18n="Consent dialog agree button@@8682986632515891204">Agree</button>
  </div>
</section>
